export default {
  Integrations: {
    header: {
      add_integration: 'Adicionar integración',
      integrations: 'Integraciones',
    },
    list: {
      integration: 'Integración',
      status: 'Status',
    },
    list_item: {
      details: 'Detalles',
      fieldview: 'Fieldview',
      google_calendar: 'Google Calendar',
      leaf_agriculture: 'NDVI',
      active: 'Activo',
      inactive: 'Inactivo',
      disabled_active_integration:
        'La integración no se puede desactivar manualmente por ahora. Póngase en contacto con el soporte.',
      disabled_inactive_integration:
        'La integración no se puede habilitar manualmente por ahora. Póngase en contacto con el soporte.',
    },
    add_modal: {
      title: 'Agregar una integración',
      action: 'Agregar',
      description:
        'Para integrar, seleccione esta opción y agréguela, junto con otras integraciones deseadas.',
      google_calendar_warning_info:
        'Las aplicaciones de todas sus cuentas y granjas que se hayan creado aparecerán en el calendario de su cuenta de Google, sin importar dónde acceda a ellas.',
      successful_authorization:
        'Autorización para Google Calendar exitosamente.',
      integrations_added: 'Las integraciones se han agregado exitosamente',
    },
    google_calendar_details: {
      title: 'Conecta tu cuenta con Google Calendar',
      infos:
        'Con esta integración, tu usuario quedará asociado a Google Calendar. Si quieres que Digifarmz deje de notificarte sobre tus aplicaciones, simplemente desactiva la integración cuando quieras',
    },
    fieldview_details: {
      title: 'Conecta tu cuenta con Climate FieldView',
      infos: 'Con esta integración, le brindaremos la siguiente información',
      fields: 'Lotes',
      farms: 'Haciendas',
    },
    leaf_agriculture_details: {
      title: 'Conecta tus haciendas con NDVI',
      infos:
        'NDVI (Normalized Difference Vegetation Index) es una herramienta de monitoreo agrícola, ambiental o de cobertura vegetal. Ayuda a identificar la salud de tu plantación a través de imágenes satelitales, las cuales serán mostradas para tus haciendas y lotes',
    },
    empty_state_details: {
      title: 'Seleccione una o más integraciones',
      text: 'Controla qué integraciones quieres tener para tu usuario/cuenta',
    },
    integration_details_modal: {
      fieldview: 'Detalles de integración del Fieldview',
      google_calendar: 'Detalles de integración del Google Calendar',
      leaf_agriculture: 'Detalles de integración del NDVI',
    },
  },
}
